module.exports = __webpack_public_path__ + "img/121.4efd4267.png";